module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aquarius/aqr_oc-4251aada234c22f3139b1a064b11a37a.gif";